import { DialogContent, Grid } from '@mui/material';
import { FC } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { IJobFieldSettings, IJobFieldSettingsType } from 'wisestep-api';
import { WsDialog, WsTypography, WsTypoVariants, WsButton, Label, WsSelect } from 'wisestep-base';

import { CurrencyTypeDropDownOptions, salaryTimeSpans } from '../../../utils';
import { HeaderBox } from '../components/HeaderBox';

export interface CustomizeDefCurrencyDialogProps {
  openDialog: boolean;
  closeDialog(): void;
  onChangeHandler: (data: IJobFieldSettingsType, value: number) => void;
  modifiedData?: Omit<
    IJobFieldSettings,
    'id' | 'workspaceId' | 'createdBy' | 'createdOn' | 'modifiedBy' | 'modifiedOn'
  >;
}
const CustomizeDefCurrencyDialog: FC<CustomizeDefCurrencyDialogProps> = ({
  openDialog,
  closeDialog,
  modifiedData,
  onChangeHandler,
}) => {
  const updaterFunction = (data: FieldValues) => {
    if (modifiedData) {
      const tData = modifiedData.defaultCurrency;
      tData.selectedField = data.currencyValue;
      onChangeHandler({ ...tData }, 2);
      closeDialog();
    }
  };

  const updateTimeSpan = (data: FieldValues) => {
    if (modifiedData?.salaryTimeSpan) {
      const timeSpanData = modifiedData.salaryTimeSpan;
      timeSpanData.selectedField = data.salaryTimeSpan;
      timeSpanData.label = 'Time Span';
      onChangeHandler({ ...timeSpanData }, 3);
      closeDialog();
    }
  };

  const methods = useForm();

  return (
    <WsDialog openDialog={openDialog} size="small">
      <DialogContent>
        <HeaderBox>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>Edit Default Currency</WsTypography>
          <WsButton onClick={() => closeDialog()}>Close</WsButton>
        </HeaderBox>
        <Grid container direction={'column'} xs={5} mt={2}>
          <FormProvider {...methods}>
            <Grid item xs={6}>
              <Label sx={{ mb: '1vw', fontWeight: 'bold' }}>Default currency:</Label>
              <WsSelect
                name="currencyValue"
                label="Currency"
                defaultValue={modifiedData?.defaultCurrency?.selectedField ?? 'USD'}
                selectArray={CurrencyTypeDropDownOptions}
              />
              <WsButton
                onClick={methods.handleSubmit((data: FieldValues) => updaterFunction(data))}
                type="submit"
              >
                Save
              </WsButton>
            </Grid>
            <Grid item xs={6} pt={2}>
              <Label sx={{ mb: '1vw', fontWeight: 'bold' }}>Time Span:</Label>
              <WsSelect
                name="salaryTimeSpan"
                label="Time Span"
                defaultValue={modifiedData?.salaryTimeSpan?.selectedField ?? 'Per Annum'}
                selectArray={salaryTimeSpans}
              />
              <WsButton
                onClick={methods.handleSubmit((data: FieldValues) => updateTimeSpan(data))}
                type="submit"
              >
                Save
              </WsButton>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </WsDialog>
  );
};
export default CustomizeDefCurrencyDialog;
